import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzwzje3ze3: FaireProductEntity = {
  token: "p_rzwzje3ze3",
  type: "product",
  name: "Matcha Latte (8oz x 12pk)",
  brandToken: "b_8em2suwmrj",
  brandName: "Laurel's Coffee",
  imageUrl: "https://cdn.faire.com/fastly/d7026cd93d68a63e46578e5a8f1330a7167264d24f1f26457f6d4860ae34bc61.png",
  galleryImageUrls: [],
  priceDollars: 30,
  description: "This one is for the tea drinkers.\n\nMade with Happy Tummy Dairy as always, this is a perfect blend of matcha, vanilla extract, and creamy, indulgent dairy.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:10.099Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
